export default "__VITE_ASSET__BGgJAZxu__"